import { axiosServiceNowApi } from 'services/Api'
import { Dispatch } from 'redux'
import { AxiosResponse, AxiosError } from 'axios'
import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { REDUX } from 'constants/'
import store from 'store'
import NotificationService from 'services/Notification'

import {
    IAccountabilityMatrix,
    LondonVariblesTypes,
    NotificationGetCountGroupBy,
    NotificationType,
    ResultNotificationActionPlan,
    IBatchActionPlanRequest
} from 'types/notification'
import {
    ResultNotificationGetCountGroupBy,
    NotificationAction,
    ResultNotificationGetAllPaginate,
    ResultNotificationGetById,
    ResultNotificationGetCount,
    NotificationProcessRequiredStepsRules
} from 'types/notification'
import {
    orderNotificationFactor,
    orderNotificationVarible
} from 'utils/variblesHandler'
import { notificationStatus } from 'constants/notificationStatus'
import { ca } from 'date-fns/locale'
import { applyAuthorizationHeader } from 'helper/getAuthHeader'
import { withoutProbabilityOccurrenceForV1 } from 'utils/notificationVersion'

const NotificationActions = {
    getAllNotifications: async ({
        dispatch,
        profile,
        offset,
        limit,
        state,
        location,
        sector,
        search,
        damageLevel,
        order,
        orderby,
        subState,
        uUserType
    }: {
        dispatch: Dispatch<NotificationAction>
        profile: string
        userLocationId?: string
        offset?: string
        limit?: string
        state?: number
        location?: string
        sector?: string[]
        search?: string
        orderby?: string
        damageLevel?: string
        order?: string
        subState?: string
        uUserType?: string | null
    }): Promise<string> => {
        let sectors: string
        if (sector != null && sector.length > 0) {
            sectors = sector.toString().replaceAll(',', ';')
        }
        const url = ROUTES_NAMES.notification.get.all_notifications_paginate({
            offset,
            limit,
            state,
            location,
            sectors,
            search,
            damageLevel,
            order,
            orderby,
            subState,
            uUserType
        })

        const responseNotifications: Promise<
            AxiosResponse<ResultNotificationGetAllPaginate>
        > = axiosServiceNowApi?.get(url)
        responseNotifications
            .then((res: AxiosResponse<ResultNotificationGetById>) => {
                dispatch({
                    type: REDUX.reducers.RENDER_NOTIFICATION_SCREEN,
                    payload: res.data
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })


        let notifications = ROUTES_NAMES.notification.get.all_paginate({
            offset,
            limit,
            state,
            location,
            sectors,
            search,
            orderby
        })
        return notifications
    },
    /**
     * Executa dois webservices no serviceNow, ws para lista paginada de usuários e ws para contagem de usários totais
     * @param dispatch dispatch padrão para action user
     * @param offset numero atual da pagina solicitada
     * @param limit limite de itens por página
     */
    getAll: async ({
        dispatch,
        profile,
        offset,
        limit,
        state,
        location,
        sector,
        search,
        orderby
    }: {
        dispatch: Dispatch<NotificationAction>
        profile: string
        userLocationId?: string
        offset?: string
        limit?: string
        state?: number
        location?: string
        sector?: string[]
        search?: string
        orderby?: string
    }): Promise<string> => {
        let sectors: string
        if (sector != null && sector.length > 0) {
            sectors = sector.toString().replaceAll(',', ';')
        }

        const responseNotificationsToCount: Promise<
            AxiosResponse<ResultNotificationGetById>
        > = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.render(location, sectors, search)
        )

        const responseNotifications: Promise<
            AxiosResponse<ResultNotificationGetAllPaginate>
        > = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.all_paginate({
                offset,
                limit,
                state,
                location,
                sectors,
                search,
                orderby
            })
        )
        await Promise.all([responseNotificationsToCount, responseNotifications])
            .then(
                (
                    promisseResponse: [
                        any,
                        AxiosResponse<ResultNotificationGetAllPaginate>
                    ]
                ) => {
                    dispatch({
                        type: REDUX.reducers.RENDER_NOTIFICATION_SCREEN,
                        payload: promisseResponse[0]?.data
                    } as NotificationAction)
                    dispatch({
                        type: REDUX.reducers.GET_ALL_NOTIFICATIONS,
                        payload: promisseResponse[1]?.data?.result
                    } as NotificationAction)
                }
            )
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })

        let notifications = ROUTES_NAMES.notification.get.all_paginate({
            offset,
            limit,
            state,
            location,
            sectors,
            search,
            orderby
        })
        return notifications
    },
    getAllToDownload: async ({
        localIncident,
        sector,
        profile,
        initialDate,
        finalDate,
        dispatch
    }: {
        localIncident: string
        sector?: string[]
        profile: string
        initialDate: string
        finalDate: string
        dispatch: Dispatch<NotificationAction>
    }): Promise<string> => {

        let notifications = null;
        let sectors: string = null
        if (profile === 'location_manager') {
            if (sector != null && sector.length > 0) {
                sectors = sector.toString().replaceAll(',', ';')
            }
        }
        notifications = ROUTES_NAMES.notification.get.all_to_download_base64(localIncident, sectors, initialDate, finalDate)           

        const headers: Record<string, string> = {}
        applyAuthorizationHeader(headers)
        const options = { headers }
              store.dispatch({type: REDUX.reducers.SHOW_LOADING,payload: null})
        /*
              fetch(`${process.env.REACT_APP_PROXY_URL}${notifications}`, options)
              .then( res => res.blob() )
              .then( blob => {
                var file = window.URL.createObjectURL(blob);
                window.location.assign(file);
                store.dispatch({type: REDUX.reducers.HIDE_LOADING,payload: null})
              });
              */

        fetch(`${process.env.REACT_APP_PROXY_URL}${notifications}`, options)
                  .then(res => {
                return res.json()
            })
                  .then(json => {
                let now = new Date()
                let time = [now.getHours(), now.getMinutes(), now.getSeconds()]
                      let filename = `[${(now.toJSON().slice(0, 10))}-${time.join('-')}]_${"report_download".toLowerCase().replace(' ', '_')}.csv`
                let csv = decodeURIComponent(atob(json.data))
                const blob = new Blob([csv], { type: 'text/csv' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename
                link.click()
                      store.dispatch({type: REDUX.reducers.HIDE_LOADING,payload: null})
            })

        return notifications
    },
    getNotificationById: async (
        dispatch: Dispatch<NotificationAction>,
        id: string
    ): Promise<string> => {
        const response: Promise<AxiosResponse<ResultNotificationGetById>> =
            axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.byid(id))
        await response
            .then((res: AxiosResponse<ResultNotificationGetById>) => {
                dispatch({
                    type: REDUX.reducers.GET_CURRENT_NOTIFICATION,
                    payload: withoutProbabilityOccurrenceForV1(res.data.result[0])
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })
        return ROUTES_NAMES.notification.get.byid(id)
    },
    getNotificationByStatus: async (
        dispatch: Dispatch<NotificationAction>,
        status: number
    ): Promise<string> => {
        const response: Promise<AxiosResponse<ResultNotificationGetById>> =
            axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.byStatus(status)
            )

        await response
            .then((res: AxiosResponse<ResultNotificationGetById>) => {
                dispatch({
                    type: REDUX.reducers.GET_ALL_NOTIFICATIONS_BY_STATUS,
                    payload: res.data.result[0]
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })

        return ROUTES_NAMES.notification.get.byStatus(status)
    },
    getSumDateEventToDateNotificationTime: async (
        dispatch: Dispatch<NotificationAction>
    ) => {
        dispatch({
            type: REDUX.reducers.LOAD_NOTIFICATIONS_STAT
        } as NotificationAction)
        const response: Promise<AxiosResponse<{ totalSeconds: number }>> =
            axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.all_user_notification_statistics
            )
        await response
            .then((res: any) => {
                dispatch({
                    type: REDUX.reducers.ALL_USER_NOTIFICATION_STATISTICS,
                    payload: res.data
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })
    },
    countAllNotificationsByState: async (
        dispatch: Dispatch<NotificationAction>
    ): Promise<string> => {
        dispatch({
            type: REDUX.reducers.LOAD_NOTIFICATIONS
        } as NotificationAction)
        const responseNotifications: Promise<
            AxiosResponse<ResultNotificationGetCountGroupBy>
        > = axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.count_by_state)
        const responseNotificationsToCount: Promise<
            AxiosResponse<ResultNotificationGetCount>
        > = axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.count)
        await Promise.all([responseNotificationsToCount, responseNotifications])
            .then(
                (
                    promisseResponse: [
                        AxiosResponse<ResultNotificationGetCount>,
                        AxiosResponse<ResultNotificationGetCountGroupBy>
                    ]
                ) => {
                    const allCount = promisseResponse[0].data.result
                    const countByState = promisseResponse[1].data.result

                    let countNotifications = {
                        total: {
                            count: promisseResponse[0].data.result?.stats
                                ?.count,
                            label: 'total',
                            value: '7'
                        }
                    }

                    for (let state of countByState) {
                        const notification = notificationStatus.find(
                            (notification) =>
                                notification.value ===
                                state?.groupby_fields?.[0]?.value
                        )
                        const label = notification?.label
                        const value = notification?.value
                        const count = state?.stats?.count
                        countNotifications[label] = {
                            label: label,
                            count: count,
                            value: value
                        }
                    }
                    dispatch({
                        type: REDUX.reducers
                            .GET_COUNT_ALL_NOTIFICATIONS_BY_STATUS,
                        payload: countNotifications
                    } as NotificationAction)
                }
            )
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })

        let notifications = ROUTES_NAMES.notification.get.count_by_state
        return notifications
    },

    selectCurrentNotification: (
        dispatch: Dispatch<NotificationAction>,
        notification: NotificationType
    ): boolean => {
        dispatch({
            type: REDUX.reducers.SELECT_NOTIFICATION,
            payload: notification
        } as NotificationAction)
        return true
    },
    renderNotificationScreen: async (
        dispatch: Dispatch<NotificationAction>,
        location?: string,
        sector?: string[],
        search?: string
    ): Promise<string> => {
        let sectors: string
        if (sector != null && sector.length > 0) {
            sectors = sector.toString().replaceAll(',', ';').trim().concat(';')
        }

        const response: Promise<AxiosResponse<ResultNotificationGetById>> =
            axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.render(location, sectors, search)
            )
        await response
            .then((res: any) => {
                dispatch({
                    type: REDUX.reducers.RENDER_NOTIFICATION_SCREEN,
                    payload: res.data
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error.message
                } as NotificationAction)
            })
            .finally(() => { })

        return ROUTES_NAMES.notification.get.render(location, sectors, search)
    },
    getIshikawaByNotificationId: async (
        dispatch: Dispatch<NotificationAction>,
        id: string
    ) => {
        
        let ishikawaDiagramSysId = store?.getState()?.notificationsReducer?.ishikawaDiagram?.sys_id
        if (ishikawaDiagramSysId != id) {
            try {
                const res = await axiosServiceNowApi?.get(
                    ROUTES_NAMES.notification.get.ishikawa_by_notificationid(id)
                )
                dispatch({
                    type: REDUX.reducers.CURRENT_ISHIKAWA_DIAGRAM,
                    payload: res.data
                } as NotificationAction)
            } catch (error) {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error
                } as NotificationAction)
            }
        }
        return ROUTES_NAMES.sector.get.byid(id)
    },
    getAccountabilityMatrixByNotificationId: async (
        dispatch: Dispatch<NotificationAction>,
        id: string
    ): Promise<IAccountabilityMatrix | undefined> => {
        try {
            const res = await axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.accountability_matrix_by_notificationid(
                    id
                )
            )

            const result = res?.data?.result

            dispatch({
                type: REDUX.reducers.CURRENT_ACCOUNTABILITY_MATRIX,
                payload: result
            } as NotificationAction)

            if (Array.isArray(result)) {
                return result[0]
            }

            return result
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_NOTIFICATIONS,
                payload: error
            } as NotificationAction)

            return undefined
        }
    },
    getResultAccountabilityMatrix: async (dispatch: Dispatch<NotificationAction>,
        matrix: IAccountabilityMatrix) => {
        const response: AxiosResponse<any> = await axiosServiceNowApi?.post(
            ROUTES_NAMES.notification.post.calculate_accountability_matrix, matrix)

        return response
    },
    getLondonProtocolByNotificationId: async (
        dispatch: Dispatch<NotificationAction>,
        id: string
    ) => {

        try {
            const res = await axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.london_protocol_by_notificationid(
                    id
                )
            )
            dispatch({
                type: REDUX.reducers.CURRENT_LONDON_PROTOCOL,
                payload: res.data.result?.[0]
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_NOTIFICATIONS,
                payload: error
            } as NotificationAction)
        }

        return ROUTES_NAMES.sector.get.byid(id)
    },

    getTypesOfDiagnosis: async (dispatch: Dispatch<NotificationAction>) => {
      
        try {
            const res = await axiosServiceNowApi?.get(
                ROUTES_NAMES.notification.get.types_of_diagnosis
            )
            dispatch({
                type: REDUX.reducers.CURRENT_TYPE_OF_DIAGNOSIS,
                payload: res.data
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_NOTIFICATIONS,
                payload: error
            } as NotificationAction)
        }

        return ROUTES_NAMES.notification.get.types_of_diagnosis
    },

    getSentinelEvent: async (dispatch: Dispatch<NotificationAction>) => {
        try {
             const res = await axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.sentinel_event)
            dispatch({
                type: REDUX.reducers.CURRENT_SENTINEL_EVENT,
                payload: res.data?.result
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_NOTIFICATIONS,
                payload: error
            } as NotificationAction)
        }

        return ROUTES_NAMES.notification.get.sentinel_event
    },
    getNeverEvent: async (dispatch: Dispatch<NotificationAction>) => {
        const res = await axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.never_events
        )
        try {
            dispatch({
                type: REDUX.reducers.NEVER_EVENTS,
                payload: res.data
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_NOTIFICATIONS,
                payload: error
            } as NotificationAction)
        }

    },
    getNotificationFactors: async (dispatch: Dispatch<NotificationAction>) => {
        const response: Promise<AxiosResponse<any>> = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.notification_factors
        )
        await response
            .then((res: AxiosResponse<any>) => {
                const listOfData = res.data?.result
                const orderedFactors = orderNotificationFactor(listOfData)

                dispatch({
                    type: REDUX.reducers.GET_NOTIFICATION_FACTORS,
                    payload: orderedFactors
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error
                } as NotificationAction)
            })
            .finally(() => { })
        return ROUTES_NAMES.notification.get.notification_factors
    },

    getNotificationLondonVaribles: async (dispatch: Dispatch<NotificationAction>) => {
        const response: Promise<AxiosResponse<any>> = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.notification_london_varibles
        )

        await response
            .then((res: AxiosResponse<any>) => {
                const listOfData = res.data?.result
                const ordered: any = orderNotificationVarible(listOfData, false)
                const varibles: LondonVariblesTypes = ordered
                dispatch({
                    type: REDUX.reducers.GET_NOTIFICATION_PROTOCOL_VARIBLES,
                    payload: varibles
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_NOTIFICATIONS,
                    payload: error
                } as NotificationAction)
            })
            .finally(() => { })
        return ROUTES_NAMES.notification.get.notification_london_varibles
    },
    /**
     * Grava no redux listagem de damage level
     * @param dispatch
     */
    getDamageLevel: async (dispatch: Dispatch<NotificationAction>) => {
        const response: Promise<AxiosResponse<any>> = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.damage_level
        )
        await response
            .then((res: AxiosResponse<any>) => {
                dispatch({
                    type: REDUX.reducers.SET_DAMAGE_LEVEL_LIST,
                    payload: res?.data
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                console.error('Ocorreu um erro durante a consulta', error)
            })
    },
    getListOfActionPlan: async (
        dispatch: Dispatch<NotificationAction>,
        id: string
    ): Promise<string> => {
        dispatch({
            type: REDUX.reducers.LOADING_ALL_PLAN_ACTION
        } as NotificationAction)
        const response: Promise<AxiosResponse<ResultNotificationActionPlan>> =
            axiosServiceNowApi?.get(ROUTES_NAMES.notification.get.planAction(id))
        await response
            .then((res: AxiosResponse<ResultNotificationActionPlan>) => {
                dispatch({
                    type: REDUX.reducers.GET_ALL_PLAN_ACTION,
                    payload: res?.data?.result
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                dispatch({
                    type: REDUX.reducers.ERROR_ALL_PLAN_ACTION,
                    payload: error?.message
                } as NotificationAction)
            })
            .finally(() => { })
        return ROUTES_NAMES.notification.get.planAction(id)
    },

    setCurrentNavItem: (dispatch: Dispatch<NotificationAction>, nav: any) => {
        dispatch({
            type: REDUX.reducers.SET_CURRENT_NAV_ITEM,
            payload: nav
        } as NotificationAction)
    },
    setCurrentNotificationById: (
        dispatch: Dispatch<NotificationAction>,
        notification: any
    ) => {
        dispatch({
            type: REDUX.reducers.GET_CURRENT_NOTIFICATION,
            payload: withoutProbabilityOccurrenceForV1(notification)
        } as NotificationAction)
    },
    setProgressBarNavClicked: async (
        dispatch: Dispatch<NotificationAction>,
        isClicked: boolean
    ) => {
        dispatch({
            type: REDUX.reducers.SET_PROGRESS_BAR_NAV_CLICKED,
            payload: isClicked
        } as NotificationAction)
        return isClicked
    },
    /**
     * Grava a contagem de eventos reclassificados por unidade
     * @param dispatch
     */
    getCountLastReclassifiedIncidentType: async (dispatch: Dispatch<NotificationAction>, locationId: string) => {
        //count_last_reclassified_incident_type_by_location_id(locationId)
        const response: Promise<AxiosResponse<any>> = axiosServiceNowApi?.get(
            ROUTES_NAMES.notification.get.count_last_reclassified_incident_type_by_location_id(locationId)
        )
        await response
            .then((res: AxiosResponse<any>) => {
                dispatch({
                    type: REDUX.reducers.GET_COUNT_LAST_RECLASSIFIED_INCIDENT_TYPE,
                    payload: res?.data
                } as NotificationAction)
            })
            .catch((error: AxiosError) => {
                console.error('Ocorreu um erro durante a consulta', error)
            })
    },

    defineObjectNotificationProcessRequiredStepsRules: (dispatch: Dispatch<NotificationAction>, objectNotificationProcessRequiredStepsRules: NotificationProcessRequiredStepsRules) => {
        //count_last_reclassified_incident_type_by_location_id(locationId)
        dispatch({
            type: REDUX.reducers.NOTIFICATION_PROCESS_REQUIRED_STEPS_RULES,
            payload: objectNotificationProcessRequiredStepsRules
        } as NotificationAction)
    },

    // Actions específicas para Plano de Ação em Grupo
    getListOfActionPlanGroup: async (
        dispatch: Dispatch<NotificationAction>,
        groupId: string
    ): Promise<string> => {
        dispatch({
            type: REDUX.reducers.LOADING_ALL_PLAN_ACTION_GROUP
        } as NotificationAction)

        try {
            // TODO: Usar endpoint específico quando estiver disponível
            const response = await axiosServiceNowApi?.get(
                `/resource/notification/group/${groupId}/action_plans`
            )

            dispatch({
                type: REDUX.reducers.GET_ALL_PLAN_ACTION_GROUP,
                payload: response?.data?.result
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.ERROR_ALL_PLAN_ACTION_GROUP,
                payload: error?.message
            } as NotificationAction)
        }

        return groupId
    },

    clearActionPlanGroup: (dispatch: Dispatch<NotificationAction>) => {
        dispatch({
            type: REDUX.reducers.CLEAR_PLAN_ACTION_GROUP
        } as NotificationAction)
    },

    // Actions para Plano de Ação em Massa (Batch)
    createActionPlanBatch: async (
        dispatch: Dispatch<NotificationAction>,
        request: IBatchActionPlanRequest
    ): Promise<string> => {
        dispatch({
            type: REDUX.reducers.CREATE_BATCH_PLAN_ACTION_LOADING
        } as NotificationAction)

        try {
            const response = await NotificationService.createActionPlanBatch(request)

            dispatch({
                type: REDUX.reducers.CREATE_BATCH_PLAN_ACTION_SUCCESS,
                payload: response
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.CREATE_BATCH_PLAN_ACTION_ERROR,
                payload: error?.message
            } as NotificationAction)
        }

        return 'batch_action_plan'
    },

    clearBatchActionPlanResult: (dispatch: Dispatch<NotificationAction>) => {
        dispatch({
            type: REDUX.reducers.CLEAR_BATCH_PLAN_ACTION_RESULT
        } as NotificationAction)
    },

    // Action para atualizar planos de ação em massa
    updateActionPlanBatch: async (
        dispatch: Dispatch<NotificationAction>,
        request: IBatchActionPlanRequest
    ): Promise<string> => {
        console.log('updateBatchActionPlan action iniciada:', request)

        dispatch({
            type: REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_LOADING
        } as NotificationAction)

        try {
            console.log('Chamando NotificationService.updateBatchActionPlan...')
            const response = await NotificationService.updateActionPlanBatch(request)
            console.log('Resposta do updateBatchActionPlan:', response)

            dispatch({
                type: REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_SUCCESS,
                payload: response
            } as NotificationAction)
        } catch (error) {
            console.error('Erro no updateBatchActionPlan:', error)
            dispatch({
                type: REDUX.reducers.UPDATE_BATCH_PLAN_ACTION_ERROR,
                payload: error?.message
            } as NotificationAction)
        }

        return 'batch_action_plan_update'
    },

    // Action para deletar planos de ação em massa
    deleteActionPlanBatch: async (
        dispatch: Dispatch<NotificationAction>,
        request: IBatchActionPlanRequest
    ): Promise<string> => {
        console.log('deleteBatchActionPlan action iniciada:', request)

        dispatch({
            type: REDUX.reducers.DELETE_BATCH_PLAN_ACTION_LOADING
        } as NotificationAction)

        try {
            console.log('Chamando NotificationService.deleteBatchActionPlan...')
            const response = await NotificationService.deleteActionPlanBatch(request)
            console.log('Resposta do deleteBatchActionPlan:', response)

            dispatch({
                type: REDUX.reducers.DELETE_BATCH_PLAN_ACTION_SUCCESS,
                payload: response
            } as NotificationAction)
        } catch (error) {
            console.error('Erro no deleteBatchActionPlan:', error)
            dispatch({
                type: REDUX.reducers.DELETE_BATCH_PLAN_ACTION_ERROR,
                payload: error?.message
            } as NotificationAction)
        }

        return 'batch_action_plan_delete'
    },

    // Actions para Ishikawa em massa
    createIshikawaBatch: async (
        dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        dispatch({
            type: REDUX.reducers.CREATE_BATCH_ISHIKAWA_LOADING
        } as NotificationAction)

        try {
            const response = await NotificationService.createIshikawaBatch(request)

            dispatch({
                type: REDUX.reducers.CREATE_BATCH_ISHIKAWA_SUCCESS,
                payload: response
            } as NotificationAction)
        } catch (error) {
            dispatch({
                type: REDUX.reducers.CREATE_BATCH_ISHIKAWA_ERROR,
                payload: error?.message
            } as NotificationAction)
        }

        return 'batch_ishikawa_create'
    },

    updateIshikawaBatch: async (
        dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        console.log('updateIshikawaBatch action iniciada:', request)

        dispatch({
            type: REDUX.reducers.UPDATE_BATCH_ISHIKAWA_LOADING
        } as NotificationAction)

        try {
            console.log('Chamando NotificationService.updateIshikawaBatch...')
            const response = await NotificationService.updateIshikawaBatch(request)
            console.log('Resposta do updateIshikawaBatch:', response)

            dispatch({
                type: REDUX.reducers.UPDATE_BATCH_ISHIKAWA_SUCCESS,
                payload: response
            } as NotificationAction)
        } catch (error) {
            console.error('Erro no updateBatchIshikawa:', error)
            dispatch({
                type: REDUX.reducers.UPDATE_BATCH_ISHIKAWA_ERROR,
                payload: error?.message
            } as NotificationAction)
        }

        return 'batch_ishikawa_update'
    },

    createLondonProtocolBatch: async (
        _dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        await NotificationService.createLondonProtocolBatch(request)
        return 'batch_london_protocol_create'
    },

    updateLondonProtocolBatch: async (
        _dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        await NotificationService.updateLondonProtocolBatch(request)
        return 'batch_london_protocol_update'
    },

    createAccountabilityMatrixBatch: async (
        _dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        await NotificationService.createAccountabilityMatrixBatch(request)
        return 'batch_accountability_matrix_create'
    },

    updateAccountabilityMatrixBatch: async (
        _dispatch: Dispatch<NotificationAction>,
        request: any
    ): Promise<string> => {
        await NotificationService.updateAccountabilityMatrixBatch(request)
        return 'batch_accountability_matrix_update'
    }

}
export default NotificationActions
